import { AssignmentStatus } from '../Assignment/enums/AssignmentStatus';
import useGetStatusCounters from './hooks/useGetStatusCounterQuery';
import { ReportItem } from './components';
import {
  Visibility as VisibilityIcon,
  Done as DoneIcon,
  Add as AddIcon,
  Pause as PauseIcon,
} from '@mui/icons-material';
import { LoaderBackdrop } from '@/components';

interface ReportMeta {
  icon: JSX.Element;
  title: string;
  subtitle: string;
}

const reportMetadata: Record<AssignmentStatus, ReportMeta> = {
  [AssignmentStatus.PENDING]: {
    icon: <VisibilityIcon className="!w-[40px] lg:!w-[52px] !h-[40px] lg:!h-[52px]" />,
    title: 'Pendientes',
    subtitle: '(hasta hoy)',
  },
  [AssignmentStatus.IN_PROCESS]: {
    icon: <AddIcon className="!w-[40px] lg:!w-[52px] !h-[40px] lg:!h-[52px]" />,
    title: 'En Proceso',
    subtitle: '(hoy)',
  },
  [AssignmentStatus.SUSPENDED]: {
    icon: (
      <div className="flex items-center justify-center h-full">
        <PauseIcon className="!w-[40px] lg:!w-[52px] !h-[40px] lg:!h-[52px]" />
      </div>
    ),
    title: 'Suspendidos',
    subtitle: '(hoy)',
  },
  [AssignmentStatus.FINISHED]: {
    icon: <DoneIcon className="!w-[40px] lg:!w-[52px] !h-[40px] lg:!h-[52px]" />,
    title: 'Finalizados',
    subtitle: '(hoy)',
  },
};

const pollingInterval = 1000 * 30;

export const FleetReporting = () => {
  const { pendingReports, reportsByStatus, isLoading  } = useGetStatusCounters({
    pollingInterval,
  });
  const combinedReports = [pendingReports, ...reportsByStatus];

  if (isLoading) {
    return <LoaderBackdrop />;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 items-center justify-items-center w-full h-screen gap-4 lg:gap-8">
      {combinedReports.map(({ status, total }) => {
        const meta = reportMetadata[status];
        if (!meta) return null;

        return (
          <ReportItem
            key={status}
            amount={total}
            status={status}
            title={meta.title}
            subtitle={meta.subtitle}
            icon={meta.icon}
          />
        );
      })}
    </div>
  );
};

export default FleetReporting;
